import { ReportsController } from './reports-controller';
import { flow, sortBy, reverse, fromPairs, toPairs, keys, values } from 'lodash';

export default class extends ReportsController {
  static targets = ['pieChart']

  chartMap() {
    return Object.freeze({
      pieChart: 'pie',
      chart: 'bar'
    })
  }

  datasets() {
    return [{
      data: this.chartModel.data,
      fill: true,
      borderWidth: 2,
      hoverOffset: 4
    }]
  }

  formatReportData() {
    let data = {};

    this.reportValue.data.forEach(row => {
      if (row._type === 'data' && !(row.primary_text === null)) { // eslint-disable-line no-underscore-dangle
        if (this.chartModel.destinationId) {
          if (row.destination_id === this.chartModel.destinationId) {
            this.addRow(data, row);
          }
        } else {
          this.addRow(data, row);
        }
      }
    }, this);

    // Sort values by total (big to small)
    data = flow(toPairs, sortBy(1), reverse, fromPairs)(data);

    return {
      labels: keys(data),
      series: [],
      data: values(data).map(function(n) {
        return n.toFixed(2);
      })
    }
  }

  addRow(data, row) {
    if (row.primary_text === 'Non-Product Line Items') {
      return; // skip non product line items
    }
    data[row.primary_text] = data[row.primary_text] || 0;
    data[row.primary_text] += this.moneyToFloat(row.final_price);
  }

  getDefaultOptions(chartType, chartColor) {
    return {
      tooltips: {
        mode: 'nearest',
        position: 'average'
      },
      plugins: {
        legend: {
          display: false
        },
        autocolors: {
          customize(context) {
            const lighten = (color, value) => chartColor(color).lighten(value).rgbString();
            const colors = context.colors;
            return {
              background: lighten(colors.background, 0.3),
              border: lighten(colors.border, 0.3)
            };
          },
          mode: 'data',
          offset: 2
        }
      },
      indexAxis: 'y',
      scales: {
        x2: { display: chartType === 'bar' },
        x: {
          display: false
        },
        xAxis: {
          display: false
        }
      }
    }
  }
}
